class CustomProductMediaGallery extends HTMLElement {
  constructor() {
    super();
    this.content = this.querySelector(".custom-product-media-gallery-internal");
    this.addEventListener("click", this.eventHandler.bind(this));
  }

  eventHandler(event) {
    const thumbnail = event.target.closest(".external-video-thumbnail");
    const image = event.target.closest(
      `.product-media-gallery-item[data-media-type="image"]`
    );

    if (thumbnail) {
      const { externalVideoId } = thumbnail.dataset;
      this.dispatchEvent(
        new CustomEvent("openCustomMediaGalleryVideoLightbox", {
          bubbles: true,
          detail: {
            externalVideoId,
          },
        })
      );
      return;
    }

    if (image) {
      const { mediaId } = image.dataset;
      this.dispatchEvent(
        new CustomEvent("openCustomMediaGalleryLightbox", {
          bubbles: true,
          detail: {
            mediaId,
          },
        })
      );
    }
  }
}

class CustomMediaGalleryVideoLightbox extends HTMLElement {
  constructor() {
    super();
    this.domBody = document.querySelector("body");
    this.lightbox = this.querySelector(".external-video-lightbox");
    this.videoId = this.lightbox.dataset.externalVideoId;
    this.overlay = this.querySelector(".external-video-lightbox-overlay");
    this.iframe = this.querySelector("iframe");
    this.closeBtn = this.querySelector(".close-external-video-lightbox");

    this.overlay.addEventListener("click", () => this.close());
    this.closeBtn.addEventListener("click", () => this.close());

    document.addEventListener(
      "openCustomMediaGalleryVideoLightbox",
      this.customOpenHandler.bind(this)
    );
  }

  customOpenHandler(event) {
    const { externalVideoId } = event.detail;
    if (externalVideoId === this.videoId) this.open();
  }

  close() {
    this.lightbox.dataset.lightboxOpen = false;
    this.pauseVideo();
    this.domBody.classList.remove("overflow-hidden");
  }

  open() {
    this.lightbox.dataset.lightboxOpen = true;
    this.domBody.classList.add("overflow-hidden");
  }

  pauseVideo() {
    const src = this.iframe.src;
    this.iframe.src = src;
  }
}

class CustomMediaGalleryLightbox extends HTMLElement {
  constructor() {
    super();
    this.domBody = document.querySelector("body");
    this.closeBtn = this.querySelector("#close-gallery-lightbox");
    this.content = this.querySelector("#custom-media-gallery-lightbox-content");

    document.addEventListener("openCustomMediaGalleryLightbox", (e) => {
      const { mediaId } = e.detail;
      this.setThumbnailActiveState(mediaId);
      this.openGalleryLightbox();
      this.scrollMainImageIntoView(mediaId);
    });

    this.closeBtn.addEventListener(
      "click",
      this.closeBtnEventHandler.bind(this)
    );

    this.content.addEventListener("click", this.contentEventHandler.bind(this));
  }

  closeBtnEventHandler(e) {
    const btn = e.target.closest("#close-gallery-lightbox");
    if (!btn) return;
    this.closeGalleryLightBox();
  }

  contentEventHandler(e) {
    const lightboxThumbnail = e.target.closest(".lightbox-thumbnail");
    if (lightboxThumbnail) {
      const { mediaId } = lightboxThumbnail.dataset;
      this.resetThumbnailsActiveState();
      lightboxThumbnail.dataset.activeThumbnail = true;
      this.scrollMainImageIntoView(mediaId);
      return;
    }
    this.closeGalleryLightBox();
  }

  scrollMainImageIntoView(mediaId) {
    const mainImage = this.querySelector(
      `.lightbox-main-image[data-media-id="${mediaId}"]`
    );
    mainImage.scrollIntoView({
      behavior: "smooth",
      block: "center",
    });
  }

  setThumbnailActiveState(mediaId) {
    const thumbnail = this.querySelector(
      `.lightbox-thumbnail[data-media-id="${mediaId}"]`
    );
    thumbnail.dataset.activeThumbnail = true;
  }

  resetThumbnailsActiveState() {
    this.querySelectorAll(".lightbox-thumbnail").forEach(
      (el) => (el.dataset.activeThumbnail = false)
    );
  }

  closeGalleryLightBox() {
    this.dataset.openGalleryLightbox = false;
    this.domBody.classList.remove("overflow-hidden");
    this.resetThumbnailsActiveState();
  }

  openGalleryLightbox() {
    this.dataset.openGalleryLightbox = true;
    this.domBody.classList.add("overflow-hidden");
  }
}

customElements.define(
  "custom-product-media-gallery",
  CustomProductMediaGallery
);

customElements.define(
  "custom-media-gallery-video-lightbox",
  CustomMediaGalleryVideoLightbox
);

customElements.define(
  "custom-media-gallery-lightbox",
  CustomMediaGalleryLightbox
);
